import React, { useState } from "react";
import ReactDom from "react-dom";
import Input from "../UIResuableComponents/CreateForm/Input";
import { MdOutlineCancel } from "react-icons/md";
import ButtonToAdd from "../UIResuableComponents/ButtonToAdd";

function CreateProduction(props) {
  const [noOfField, setNoOfField] = useState(1);
  const onAddExtraField = (e) => {
    e.preventDefault();
    setNoOfField((prevState) => prevState + 1);
  };

  const repeatedData = () => {
    let listItem = [];
    let list = "";
    for (let i = 1; i <= noOfField; i++) {
      list = (
        <div className="w-full items-center mb-10">
          <div className="w-[100%] mb-4 ">
            {props.FormOptionsProduction.map((item) => {
              return (
                <Input
                  key={item.labelName}
                  valueLabel={item.valueLabel}
                  onInputChangeHandler={props.onInputChangeHandler}
                  type={item.type}
                  Name={item.labelName}
                  index={i - 1}
                  value={props.inputFormData[item.valueLabel][i - 1]}
                  placeholder={item.placeholder}
                  isRequired={item.isRequired}
                  options={item.options ? item.options : ""}
                  CustomInputStyle={item.CustomInputStyle}
                  // errorMsg={props.ErrorData[item.valueLabel]}
                />
              );
            })}
          </div>
          <div>
            <table className="border  border-[1px] border-btnbgcolorlight  font-medium rounded">
              <thead className="border border-[1px]  border-btnbgcolorlight  font-medium rounded">
                <tr className="border border-[1px]  border-btnbgcolorlight  font-medium rounded">
                  <th
                    className="border border-[1px]  border-btnbgcolorlight  font-medium py-1  rounded"
                    colSpan="4"
                  >
                    Quality
                  </th>
                  <th className="border border-[1px]  border-btnbgcolorlight  font-medium	 py-1  rounded">
                    Nepali Total
                  </th>
                  <th className="border border-[1px]  border-btnbgcolorlight  font-medium	 py-1  rounded">
                    Germany Total
                  </th>
                </tr>
                <tr>
                  <th
                    className="border border-[1px]  border-btnbgcolorlight  font-medium	 py-1  rounded"
                    rowSpan="2"
                  >
                    Germany
                  </th>
                  <th
                    className="border border-[1px]  border-btnbgcolorlight  font-medium py-1  rounded"
                    colSpan="3"
                  >
                    Nepali
                  </th>
                  <th
                    className="border border-[1px] border-btnbgcolorlight  font-medium py-1	  rounded"
                    rowSpan="2"
                  ></th>
                </tr>
                <tr>
                  <th className="border border-[1px] border-btnbgcolorlight  font-medium whitespace-nowrap  py-1  rounded">
                    Burnt And Bubble
                  </th>
                  <th className="border border-[1px] border-btnbgcolorlight  font-medium py-1  rounded">
                    Broken Edge
                  </th>
                  <th className="border border-[1px] border-btnbgcolorlight  font-medium py-1  rounded">
                    Poor Leaf
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  {Object.keys(props.InitialFormProductionTable).map(
                    (item, index) => {
                      return (
                        <td className="border border-[1px]  border-btnbgcolorlight  text-center font-medium ">
                          <input
                            type="text"
                            className="w-full px-2 py-2 outline-none"
                            placeholder="Enter Quantity"
                            name={item}
                            value={
                              props.InitialFormProductionTable[item][i - 1]
                            }
                            onChange={(e) =>
                              props.onInputChangeHandlerTable(e, i - 1)
                            }
                          />
                        </td>
                      );
                    }
                  )}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      );
      listItem.push(list);
    }
    return listItem;
  };

  const form = (
    <div
      className={`py-4 md:py-4 rounded-lg max-w-7xl	  overflow-y-scroll  custom-scroll-for-nav  ${
        props.FormStyle ? `${props.FormStyle}` : "shadow-overlayshadow"
      } px-4 bg-bgwhite md:w-[40%] fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] z-30  `}
    >
      <div
        onClick={props.onClickClose}
        className="absolute top-[3%] right-[5%] text-2xl cursor-pointer text-btnbgcolor"
      >
        <MdOutlineCancel />
      </div>
      <div className="mb-6">
        <h1 className="text-btnbgcolor mb-1 text-sm md:text-lg font-semibold text-center">
          {props.CreateName.toUpperCase()}
        </h1>
        <p className="mb-3 text-xs lg:text-lg text-center">
          Enter your credentials to {props.CreateName.toLowerCase()}
        </p>
        <form
          className="flex  flex-col  py-8"
          onSubmit={props.onSubmitAdjustData}
        >
          <div className="flex flex-col">{repeatedData()}</div>
          <div className="inline-block">
            <ButtonToAdd text={"Add More"} onClick={onAddExtraField} />
          </div>
        </form>
      </div>
    </div>
  );

  return ReactDom.createPortal(form, document.querySelector("#over-lay"));
}

export default CreateProduction;
